import skfImg from '../../../assets/images/calc-1.png';
import imtImg from '../../../assets/images/calc-2.png';
import scoreImg from '../../../assets/images/calc-3.png';
import chaImg from '../../../assets/images/calc-4.png';
import hasBledImg from '../../../assets/images/calc-5.png';
import graceImg from '../../../assets/images/calc-6.png';
import pesiImg from '../../../assets/images/calc-7.png';
import paduaImg from '../../../assets/images/calc-8.png';
import daptImg from '../../../assets/images/calc-9.png';

export const calculators: {
  name: string;
  iconSrc: any;
  url?: string;
  button?: string;
}[] = [
  { name: 'skf', iconSrc: skfImg },
  { name: 'cockcroft-gault', iconSrc: skfImg },
  { name: 'imt', iconSrc: imtImg },
  { name: 'score', iconSrc: scoreImg },
  {
    name: 'score-2',
    iconSrc: scoreImg,
    url:
      'https://heartscore.escardio.org/calculate/quickcalculator.aspx?model=veryhigh',
    button: 'Перевірити',
  },
  {
    name: 'drug-interactions',
    iconSrc: '',
    url: 'https://reference.medscape.com/drug-interactionchecker',
    button: 'Перевірити',
  },
  { name: 'cha', iconSrc: chaImg },
  // { name: 'has-bled', iconSrc: hasBledImg },
  { name: 'grace', iconSrc: graceImg },
  { name: 'pesi', iconSrc: pesiImg },
  { name: 'padua-scale', iconSrc: paduaImg },
  { name: 'dapt-scale', iconSrc: daptImg },
  { name: 'goodwill', iconSrc: '' },
  { name: 'miocard', iconSrc: '' },
  // { name: 'dapt-precise', iconSrc: daptImg },
];
